import script from "./MyCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./MyCollection.vue?vue&type=script&setup=true&lang=js"

import "./MyCollection.vue?vue&type=style&index=0&id=02603c38&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02603c38"]])

export default __exports__